module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tk-sku_popup",
    attrs: {
      "data-com": "TkSkuPopup"
    }
  }, [_c('YuPopup', {
    attrs: {
      "value": _vm.onPop
    },
    on: {
      "input": _vm.fnPopChange
    }
  }, [(_vm.onPop) ? _c('div', {
    staticClass: "tk-sku_popup-box"
  }, [_c('div', {
    staticClass: "tk-sku_popup-info"
  }, [_c('div', {
    staticClass: "tk-sku_popup-img_box"
  }, [_c('img', {
    staticClass: "tk-sku_popup-img",
    attrs: {
      "src": _vm._f("imgURL")(_vm.oPro.feature_image, '172x172'),
      "alt": _vm.oPro.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tk-sku_popup-pro"
  }, [_c('div', {
    staticClass: "tk-sku_popup-name"
  }, [_vm._v(_vm._s(_vm.oPro.name))]), _vm._v(" "), [_c('div', {
    staticClass: "tk-sku_popup-prices"
  }, [_c('YuCurrency', {
    staticClass: "tk-sku_popup-price",
    attrs: {
      "val": _vm.amountAfter
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "tk-sku_popup-count"
  }, [_c('span', [_vm._v("已售 " + _vm._s(_vm.nNowSale) + " 件")])])], 2), _vm._v(" "), _c('YuButton', {
    staticClass: "tk-sku_popup-close",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.fnClose
    }
  }, [_c('img', {
    staticClass: "tk-sku_popup-close_icon",
    attrs: {
      "src": require("./close.svg")
    }
  })])], 1), _vm._v(" "), ((_vm.oPro.options || []).length) ? _c('div', {
    staticClass: "tk-sku_popup-chooser"
  }, [_c('YuScrollView', {
    staticClass: "tk-sku_popup-scroll_view"
  }, [_c('TkSkuChooser', {
    attrs: {
      "sku": this.nNowSku,
      "skus": _vm.oPro.variants,
      "options": _vm.oPro.options
    },
    on: {
      "change": _vm.fnChooser
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type !== 'cart') ? _c('div', {
    staticClass: "tk-sku_popup-num"
  }, [_c('div', {
    staticClass: "tk-sku_popup-num_label"
  }, [_c('span', [_vm._v("购买数量")]), (_vm.nSumStock !== null) ? _c('span', {
    staticClass: "tk-sku_popup-stock"
  }, [_vm._v("（库存 " + _vm._s(_vm.nNowStock) + " 件）")]) : _vm._e()]), _vm._v(" "), _c('YuAmount', {
    model: {
      value: (_vm.nNowQuantity),
      callback: function($$v) {
        _vm.nNowQuantity = $$v
      },
      expression: "nNowQuantity"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tk-sku_popup-btns"
  }, [_c('YuButton', {
    staticClass: "tk-sku_popup-ok",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fnSubmit
    }
  }, [_vm._v("立即购买")])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbb9e10a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/Sku/Popup.vue
// module id = 296
// module chunks = 0